import { keepPreviousData, queryOptions } from "@tanstack/react-query"
import { z } from "zod"
import { PROJECT_STATUSES } from "@/features/project-status/core/projectStatus"
import { reportsQueryKeys } from "@/lib/queryKeys"
import { getStoresBySizeReport, type StoresBySizeParams } from "../../server/storesBySizeServer"

export const StoresBySizeSearchParams = z.object({
  status: z.enum(PROJECT_STATUSES).optional(),
  pageIndex: z.coerce.number().int().min(0).optional(),
  pageSize: z.coerce.number().int().min(1).max(200).optional(),
})

export type StoresBySizeSearchValues = z.infer<typeof StoresBySizeSearchParams>

export const STORES_BY_SIZE_DEFAULTS = {
  status: "approved" as const,
  pageIndex: 0,
  pageSize: 25,
}

export const applyStoresBySizeDefaults = (s: StoresBySizeSearchValues): StoresBySizeParams => ({
  status: s.status ?? STORES_BY_SIZE_DEFAULTS.status,
  pageIndex: s.pageIndex ?? STORES_BY_SIZE_DEFAULTS.pageIndex,
  pageSize: s.pageSize ?? STORES_BY_SIZE_DEFAULTS.pageSize,
})

export const storesBySizeQuery = (params: StoresBySizeParams) =>
  queryOptions({
    queryKey: reportsQueryKeys.storesBySize(params),
    queryFn: () => getStoresBySizeReport({ data: params }),
    placeholderData: keepPreviousData,
  })
